import { COUNTRIES_ID } from '@shared/enum/country.enum';

export interface Country {
  id: COUNTRIES_ID;
  name: string;
  code: string;
  icon: string;
}

export const publicCountries: Record<COUNTRIES_ID, Country> = {
  [COUNTRIES_ID.CN]: {
    id: COUNTRIES_ID.CN,
    name: 'China',
    code: '+86',
    icon: 'assets/images/flag-zh.png',
  },
  [COUNTRIES_ID.FR]: {
    id: COUNTRIES_ID.FR,
    name: 'France',
    code: '+33',
    icon: 'assets/images/flag-fr.png',
  },
  [COUNTRIES_ID.JP]: {
    id: COUNTRIES_ID.JP,
    name: 'Japan',
    code: '+81',
    icon: 'assets/images/flag-ja.png',
  },
  [COUNTRIES_ID.US]: {
    id: COUNTRIES_ID.US,
    name: 'United States',
    code: '+1',
    icon: 'assets/images/flag-en.png',
  },
  [COUNTRIES_ID.VN]: {
    id: COUNTRIES_ID.VN,
    name: 'Viet Nam',
    code: '+84',
    icon: 'assets/images/flag-vi.png',
  },
};
